import React, { useEffect, useState } from "react";
import { TieredMenu } from "primereact/tieredmenu";
import { Link, useLocation } from "react-router-dom";
import "../assets/css/sidemenu.css";
import { Menu } from 'primereact/menu';
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Tooltip } from "primereact/tooltip";
import packageJson from "../../package.json";
import { taxDbName } from "../services/envhttp";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import axios from "axios";
function SideMenu() {

  const [collapsed, setCollapsed] =  useState(false);
  const [selectedClientName, setSelectedClientName] = useState(
    localStorage.getItem("taxSelectedClientName") || ""
  );

  const navigate = useNavigate();

  const location = useLocation();
  const radixTestUrl = process.env.REACT_APP_TAX_URL;
  const envBaseUrl = process.env.REACT_APP_TAX_APP_URL || '';
  const sessionContextEndpoint = `${envBaseUrl}/ztx_firm_ctx/v1/`;
  const token = localStorage.getItem("taxToken");
  
  const dbName = taxDbName || "N/A";

  useEffect(() => {
    const syncSelectedClient = () => {
      setSelectedClientName(localStorage.getItem("taxSelectedClientName") || "");
    };
    window.addEventListener("taxSelectionChanged", syncSelectedClient);
    return () => window.removeEventListener("taxSelectionChanged", syncSelectedClient);
  }, []);


  const itemRenderer = (item) => {

    const isActive = location.pathname === item.link;
    const tooltipClass = `tooltip-${item.label.replace(/\+/g, "")}`

    return (
      <>
      {collapsed && (
        <Tooltip target={`.${tooltipClass}`} position="right" />
      )}
    <Link
      to={item.link}
      className={`p_menuitem-link custom-menu-item ${isActive ? "active-menu-item" : ""} ${tooltipClass}`}
      style={{ textDecoration: "none", display: "flex", alignItems: "center", padding: "0.625rem",
        justifyContent: collapsed ? "center" : "flex-start", gap: collapsed ? "0px" : "0.75rem",
        transition: "all 0.3s ease" 
      }} data-pr-tooltip={collapsed?item.label:""} data-pr-position="right"
    >
      <span className={`${item.icon} p-menuitem-icon`} style={{fontSize: "1.125rem", color: "#333"}} />
      {!collapsed && (
        <span className="p-menuitem-text" style={{fontSize: "1.125rem", color: "#333"}}>
          {item.label}
        </span>
      )}
    </Link>
    </>
    )
  };

  const items = [
    {
          label: "Clients",
          link: "/Pages/Clients",
          icon: "pi pi-users",
          template: itemRenderer,
      },
      {
          label: "TaxReturns",
          link: "/Pages/TaxReturns",
          icon: "pi pi-file",
          template: itemRenderer,
      },
      {
          label: "TaxDocuments",
          link: "/Pages/TaxDocuments",
          icon: "pi pi-file-pdf",
          template: itemRenderer,
      },
      {
          label: "Tasks",
          link: "/Pages/Tasks",
          icon: "pi pi-bookmark",
          template: itemRenderer,
      },
      {
          label: "TaskTaxTopics",
          link: "/Pages/TaskTaxTopics",
          icon: "pi pi-check-square",
          template: itemRenderer,
      },
      {
          label: "W2s",
          link: "/Pages/W2s",
          icon: "pi pi-money-bill",
          template: itemRenderer,
      },
      {
          label: "1099Divs",
          link: "/Pages/1099Divs",
          icon: "pi pi-wallet",
          template: itemRenderer,
      },
      {
          label: "1099Ints",
          link: "/Pages/1099Ints",
          icon: "pi pi-percentage",
          template: itemRenderer,
      },
      {
          label: "1099Bs",
          link: "/Pages/1099Bs",
          icon: "pi pi-briefcase",
          template: itemRenderer,
      },
      {
          label: "K1s",
          link: "/Pages/K1s",
          icon: "pi pi-file-edit",
          template: itemRenderer,
      },
      {
          label: "Rentals",
          link: "/Pages/Rentals",
          icon: "pi pi-building",
          template: itemRenderer,
      },
  ];

  const handleLogout = () => {
    localStorage.clear();
    window.dispatchEvent(new Event("taxSelectionChanged"));
    navigate("/login")
  }

  const confirmLogout = () => {
    confirmDialog({
      message: "Are you sure want to logout?",
      header: "Logout Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: handleLogout,
    })
  }
  const logoutButton = (
    <Button label="Logout" icon="pi pi-sign-out" onClick={confirmLogout} />
  )

  return (
  <>
  <ConfirmDialog />
  <div style={{width: collapsed? "5rem" : "17.5rem",
    height: "100vh",
    background: "#f1f5f9",
    transition: "0.3s",
    display:"flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexShrink: 0
  }}>
  <div>
  <div style={{ display: "flex", justifyContent: collapsed ? "center" : "space-between",alignItems: "center", padding: "0.625rem"}}>
  {!collapsed && (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "0.15rem" }}>
      <h2 style={{ color: "#006B88", textAlign: "left", margin: "0.25rem 0 0 0" }}>
        Radix Tax App
      </h2>
      <span style={{ fontSize: "0.75rem", color: "#64748b" }}>
        Version: {packageJson.version}
      </span>
      <span style={{ fontSize: "0.75rem", color: "#64748b" }}>
        DB: {dbName}
      </span>
    </div>
  )}
  <Button icon={collapsed ? "pi pi-angle-right" : "pi pi-angle-left"} rounded tooltip="Toggle" onClick={() => setCollapsed(!collapsed)} />
  </div>
  {!collapsed && selectedClientName && (
    <div className="selected-client-context">
      <span className="selected-client-label">Selected client</span>
      <strong>{selectedClientName}</strong>
    </div>
  )}
  <TieredMenu model={items} style={{width: "100%", border: "none" , background: "#f1f5f9"}} />
  </div>
  <div style={{padding: "0.9375rem"}}>
    <Divider />
    <Button label={collapsed ? "" : "Logout"} icon="pi pi-sign-out"  tooltip={collapsed ? "Logout" : ""} className = "w-full" onClick={confirmLogout} />
  </div>
  </div>
  </>
  );
}

export default SideMenu;